// extracted by mini-css-extract-plugin
module.exports = {"cls1":"LoadingSheet-Container-module--cls1--3dSg1","cls2":"LoadingSheet-Container-module--cls2--1lifY LoadingSheet-Container-module--cls1--3dSg1"};